/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import styled, { css } from 'styled-components'
import { VerticalStyledScrollBar } from '~/styles'

interface IBodyStyle {
  isLoading?: boolean
  background?: string
  maxHeight?: string
}

export const BodyStyle = styled.div.attrs(props => ({
  scrollbarBackground: props.theme.zds.colors.neutral1000
}))<IBodyStyle>`
  overflow: auto;
  ${({ maxHeight }) => css`
    max-height: ${maxHeight || ''};
  `}
  flex: 1 1 auto;
  ${VerticalStyledScrollBar}

  ${({ background }) => css`
    background: ${background || 'transparent'};
  `}

  font-size: 14px;
  color: ${props => props.theme.colors.color2d3139};

  ${({ isLoading }) =>
    isLoading &&
    css`
      align-items: center;
    `}
`

interface Line {
  height?: string
  noHover?: boolean
  separator?: boolean
  isExpandedLine?: boolean
}

export const LineStyle = styled.div<Line>`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 100%;
  min-width: fit-content;
  height: ${({ height }) => (height ? `${height}` : '51px')};
  padding-left: 24px;
  line-height: 18px;

  ${({ separator }) =>
    separator
      ? css`
          & + & {
            border-top: 1px solid rgba(233, 238, 248, 0.8);
          }
        `
      : css`
          border-top: none !important;
        `}

  ${({ isExpandedLine, theme }) =>
    isExpandedLine &&
    css`
      background-color: ${theme.colors.colorf7f9fc};
    `}

  ${({ noHover, theme }) =>
    !noHover &&
    css`
      cursor: pointer;
      &:hover,
      &:active {
        background-color: ${theme.colors.colorf7f9fc};
      }
    `}
`

export interface Cell {
  width?: string
  minWidth?: string
  maxWidth?: string
  length: number
}

export const CellStyle = styled.div<Cell>`
  ${({ width }) =>
    width &&
    `
        width: ${width};
    `}

  ${({ minWidth }) =>
    minWidth &&
    `
        min-width: ${minWidth};
    `}

    ${({ maxWidth }) =>
    maxWidth &&
    `
        max-width: ${maxWidth};
    `}

    ${({ width, maxWidth }) =>
    !width &&
    !maxWidth &&
    `
        flex: 1;
    `}
`

export const ExpandableCellStyle = styled.div<Cell>`
  position: absolute;
  top: 50%;
  left: 5px;
  transform: translateY(-50%);
`

export const ExpandableLine = styled.div`
  position: relative;
  width: 100%;
  min-width: fit-content;
`

export const P = styled.div`
  font-size: 14px;
  text-transform: capitalize;
`

export const IconDiv = styled.div``
